import(/* webpackMode: "eager" */ "/vercel/path0/apps/discovericl/app/global-error.tsx");
